import type {
  ExecutionFileChange,
  ExecutionFlowNode,
  ExecutionVisualChange,
} from "../types";

interface VisualChangeEntry {
  file: ExecutionFileChange;
  change: ExecutionVisualChange;
}

export function extractVisualChanges(
  node: ExecutionFlowNode,
): VisualChangeEntry[] {
  return node.file_changes
    .map((file) => {
      const change = file.ui_ux_visual_change ?? null;
      return change?.summary ? { change, file } : null;
    })
    .filter((entry): entry is VisualChangeEntry => Boolean(entry));
}

export function extractVisualRefinementNotes(
  node: ExecutionFlowNode,
): string[] {
  return (node.review_feedback ?? [])
    .map((feedback) =>
      typeof feedback.message === "string" ? feedback.message.trim() : "",
    )
    .filter((message): message is string => Boolean(message))
    .filter((message) => /^gemini visual refinement/i.test(message))
    .map((message) => message.replace(/\s*\[file=.*\]\s*$/i, "").trim())
    .filter((message, index, arr) => message && arr.indexOf(message) === index);
}

export function getNormalizedFilepath(
  feedback: NonNullable<ExecutionFlowNode["review_feedback"]>[number],
): string | null {
  if (typeof feedback.normalized_filepath === "string") {
    return feedback.normalized_filepath;
  }
  return null;
}
